import * as React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function VideoShowcase() {
  return <section data-section-id="253759" id="videoshowcase" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 max-w-5xl text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-default mb-12 text-foreground tracking-tight">
          <span className="font-semibold !text-6xl !text-[rgba(21,165,150,1)]">BEWEI. Der Film. </span>{" "}
          
        </h2>
        
        <div className="w-full overflow-hidden rounded-3xl shadow-lg border border-border/30 bg-muted/10">
          <AspectRatio ratio={16 / 9}>
            <iframe className="w-full h-full rounded-3xl" src="https://www.youtube-nocookie.com/embed/SNJj20j0IE8?rel=0&showinfo=0" title="DERMA Beauty Lounge Imagefilm" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
          </AspectRatio>
        </div>
      </div>
    </section>;
}